/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoAutomaticHandoverInput = {
    clientMutationId?: string | null;
    shipmentSlug: string;
    handoverDate?: string | null;
};
export type ShipmentAutomaticHandoverMutationVariables = {
    input: infoAutomaticHandoverInput;
};
export type ShipmentAutomaticHandoverMutationResponse = {
    readonly infoAutomaticHandover: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ShipmentAutomaticHandoverMutation = {
    readonly response: ShipmentAutomaticHandoverMutationResponse;
    readonly variables: ShipmentAutomaticHandoverMutationVariables;
};



/*
mutation ShipmentAutomaticHandoverMutation(
  $input: infoAutomaticHandoverInput!
) {
  infoAutomaticHandover(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoAutomaticHandoverPayload",
    "kind": "LinkedField",
    "name": "infoAutomaticHandover",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShipmentAutomaticHandoverMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShipmentAutomaticHandoverMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e7200c647a42852e4db7727ee64551dc",
    "id": null,
    "metadata": {},
    "name": "ShipmentAutomaticHandoverMutation",
    "operationKind": "mutation",
    "text": "mutation ShipmentAutomaticHandoverMutation(\n  $input: infoAutomaticHandoverInput!\n) {\n  infoAutomaticHandover(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '9c02a11f4017f1e350132a7bcd443238';
export default node;
